import { Component, input } from '@angular/core';

import { ButtonComponent, IconType, TooltipHoverDirective } from '@evc/web-components';

@Component({
  selector: 'action-icon',
  templateUrl: './action-icon.component.html',
  styleUrls: ['./action-icon.component.scss'],
  imports: [
    TooltipHoverDirective,
    ButtonComponent,
  ],
})
export class ActionIconComponent {
  public readonly icon = input<IconType>();
  public readonly name = input<string>();
}
